function setCookie(cname, cvalue, exdays, minutes) {
    let expires
    let d = new Date();
    if (minutes) {
        d.setTime(d.getTime() + (minutes * 60 * 1000));
    } else {
       
        if (exdays == 0) {
            expires = "expires=0";
        } else {
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
        }
    }
    expires = "expires="+ d.toUTCString();    
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
}

export {
    setCookie,
    getCookie
}